const styles = theme => ({
  loader: {
    backgroundColor: '#000',
    height: 3,
  },
});

export default styles;
